<div class="container-fluid mt-1">
  <!-- Título -->
  <div class="row">
    <div class="col-6 mx-auto text-center text-white">
      <app-alert [titulo]="'Tableros de control'"></app-alert>
    </div>
  </div>

  <!-- Dashboard Metabase -->
  <div class="row m-2 dashboard-frame">
    <div class="col-12 h-100 p-0">
      <div *ngIf="isLoading" class="dashboard-frame__loading" role="status" aria-live="polite">
        <div class="dashboard-frame__spinner" aria-hidden="true"></div>
        <div>{{ isTakingLong ? 'El tablero está tardando más de lo habitual. Seguimos intentando cargarlo…' : 'Cargando tablero…' }}</div>
      </div>
      <div *ngIf="loadError" class="dashboard-frame__error" role="alert">
        <span>{{ loadError }}</span>
        <button type="button" class="btn btn-primary btn-sm" (click)="retryLoading()">Reintentar</button>
      </div>
      <iframe *ngIf="metabaseUrl"
              [src]="metabaseUrl"
              name="sniperIframe"
              class="dashboard-frame__iframe"
              (load)="onDashboardLoad()"
              (error)="onDashboardError()"
              frameborder="0"
              allowtransparency>
      </iframe>
    </div>
  </div>

</div>
